import { Component, OnInit,  ViewChild, Input, Output } from '@angular/core';
import {NgIf} from '@angular/common';
import { Router }            from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap';
import { ModalModule } from 'ng2-bootstrap/modal';
import { ApplicationContextService }         from './app-context.service';
import {ColorMode }         from './app-context.service';
import { QuickLinkComponent }         from './quicklink.component';
@Component({
 //   moduleId: module.id,
  selector: 'consult',
  templateUrl: './consult.component.html',
  styleUrls:  ['./content.component.css','./consult.component.css']
})
export class ConsultComponent implements OnInit {

  constructor(
    private appContextService: ApplicationContextService,
    private router: Router) { }
  ngOnInit(): void {
       this.appContextService.SetURL(this.router.url);
   this.appContextService.SetSubject(""); 
        this.appContextService.SetMode(ColorMode.White);
    
  }


}

